export default "__VITE_ASSET__8xqhtvWJ__"